module.exports = __webpack_public_path__ + "media/images/faces/face27-61a7b01b0de50d621183fe39d48be12d.jpg";